// UCs geradoras das usinas da Vigor — é o que separa, no Resumo da planilha, a injeção
// que veio de usina nossa da que veio de geração de terceiro.
//
// A fonte é `usinas_vigor_numeros()` (src/lib/usinasVigor.ts): o número longo E o curto
// de cada usina de `rateio_unidades_geradoras`. Até 07/10/2026 só o longo entrava, e as
// contas que trazem o curto (ex.: 10036788990, Vera Cruz 03) caíam como terceiro. Vale a
// lista INTEIRA, inclusive UG inativa: uma usina desligada este mês continua tendo sido
// nossa nas faturas do mês passado.
//
// O cache é de módulo porque a planilha abre e fecha várias vezes na mesma sessão e a
// lista muda uma vez por trimestre — não faz sentido consultar a cada abertura. Falha
// (RLS, rede) não vira erro na tela: devolve null, e o Resumo cai na coluna única de
// injeção em vez de classificar errado.

import { useEffect, useState } from 'react';
import { carregarUsinasVigor } from '../../../../src/lib/usinasVigor';

let cache: Promise<Set<string> | null> | null = null;

async function buscar(): Promise<Set<string> | null> {
  // As chaves já vêm limpas do mesmo jeito que limparUcGeradora (só dígitos, sem zeros à
  // esquerda). Cadastro vazio vem como null: não dá para dizer que toda injeção é de
  // terceiro só porque ninguém preencheu o número da usina.
  const usinas = await carregarUsinasVigor();
  return usinas ? new Set(usinas.keys()) : null;
}

export function carregarUcsGeradorasVigor(): Promise<Set<string> | null> {
  if (!cache) cache = buscar().catch(() => null);
  return cache;
}

/** `null` enquanto carrega e também quando não deu para saber — quem usa trata os dois
 *  do mesmo jeito: sem a lista, não se separa a injeção por origem. */
export function useUcsGeradorasVigor(ativo: boolean): Set<string> | null {
  const [ucs, setUcs] = useState<Set<string> | null>(null);
  useEffect(() => {
    if (!ativo) return;
    let vivo = true;
    carregarUcsGeradorasVigor().then(r => { if (vivo) setUcs(r); });
    return () => { vivo = false; };
  }, [ativo]);
  return ucs;
}
